import Swiper from "swiper";

export default () => {
  placesSlider();
  teamSlider();
  setTimeout(function(){
    projectsSlider();
  }, 1000);

  function placesSlider() {
    let slider = document.querySelector(".places__slider");
    if (slider) {
      let mainSlider = new Swiper(slider, {
        wrapperClass: "places__slider-wrapper",
        slideClass: "places__slide",
        slideActiveClass: "places__slide--active",
        slideDuplicateActiveClass: "places__slide--active",
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        speed: 600,
        touchStartPreventDefault: false,
      });
    }
  }

  function teamSlider(){

    let slider = document.querySelector(".h-team__slider");
    if(slider){
        let mainSlider = new Swiper(slider, {
        wrapperClass: "h-team__slider-wrapper",
        slideClass: "h-team__slide",
        slidesPerView: 1,
        grabCursor: false,
        loop: true,
        spaceBetween:10,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        lazy: {
          loadPrevNext: true
        },
        navigation: {
          prevEl: '.team__slider-btn--prev',
          nextEl: '.team__slider-btn--next'
        },
        prevButton: '#next-button-slider',
        breakpoints: {
          600: {
            slidesPerView: 4.5,
          },

        }
      });
    }

  }

  function projectsSlider() {
    const breakpoint = window.matchMedia("(min-width:767px)");

    if (true) {
      let slider = document.querySelector(".h-projects__slider");
      if (slider) {
        let projectSlider;

        let breakpointChecker = function breakpointChecker() {
          if (breakpoint.matches === false) {
            if (projectSlider !== undefined) projectSlider.destroy(true, true);

            let media = slider.querySelectorAll('img, video');
            if (media.length) {
              setTimeout(function(){
                media.forEach(function(mediaEl) {
                  if (mediaEl.dataset.src) {
                    mediaEl.src = mediaEl.dataset.src;
                  }
                });
              }, 2000);
            }

            return;
          } else if (breakpoint.matches === true) {
            return enableSwiper();
          }
        };

        let enableSwiper = function enableSwiper() {
          projectSlider = new Swiper(slider, {
            wrapperClass: "h-projects__slider-wrapper",
            slideClass: "h-projects__slide",
            slidesPerView: 2,
            loop: true,
            autoplay:true,
            speed: 600,
            touchStartPreventDefault: false,
            lazy: {
              loadPrevNext: true
            },
            breakpoints: {
              768: {
                spaceBetween: 24,
              },
              1024: {
                spaceBetween: 44
              }
            }
          });
        };

        breakpoint.addListener(breakpointChecker);
        breakpointChecker();
      }
    }
  }
};
